export default "__VITE_ASSET__KY1X8bHz__"